import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, List } from 'core/ui/atoms';

function VariantOutlineTab(props) {
  const { selectedVariant, variants, onChange } = props;

  return (
    <Wrapper>
      <VariantList unstyled horizontal>
        {variants.map((variant) => (
          <StyledListItem key={variant?.displayName}>
            <StyledButton
              btn-outline={false}
              $isSelected={variant?.displayName === selectedVariant?.displayName}
              onClick={() => onChange(variant)}
            >
              {variant.displayName}
            </StyledButton>
          </StyledListItem>
        ))}
      </VariantList>
    </Wrapper>
  );
};

VariantOutlineTab.propTypes = {
  selectedVariant: PropTypes.object.isRequired,
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

const StyledListItem = styled(List.Item)`
  display: inline-block;
  button {
    border-right: 1px solid #36443A;
  }
  &:last-child button {
    border-right: 0;
  }
`;

const StyledButton = styled(Button)`
  padding: 12px 17px;
  border: none;
  background-color: ${(props) => props.$selected ? '#3b82f6' : '#ffffff'};
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-width: 80px;
  color: #36443A;
  font-weight: ${(props) => props.$isSelected ? '600' : '400'};
`;

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 32px;
`;

const VariantList = styled(List)`
  overflow-x: scroll;
  flex-wrap: nowrap;
  justify-content: initial;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

export default VariantOutlineTab;
